export const transactionsResource = {
  name: '交易記錄',
  fields: {
    id: '交易編號',
    sessionId: '時段編號',
    userId: '用戶',
    chargerId: '充電器',
    stationId: '站點編號',
    connectorId: '連接器',
    startTime: '開始時間',
    endTime: '結束時間',
    duration: '持續時間',
    energyDelivered: '充電量 (kWh)',
    meterStart: '起始電表',
    meterStop: '結束電表',
    amount: '金額',
    currency: '貨幣',
    paymentStatus: '付款狀態',
    paymentMethod: '付款方式',
    status: '狀態',
    stopReason: '停止原因',
    createdAt: '建立時間',
  },
  list: {
    subtitle: '檢視充電交易記錄',
  },
  show: {
    subtitle: '交易詳情',
  },
  statuses: {
    active: '進行中',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
  },
  paymentStatuses: {
    pending: '待付款',
    paid: '已付款',
    failed: '付款失敗',
    refunded: '已退款',
  },
};

export const transactions = {
  transactions: transactionsResource,
};